import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { roundValue } from '~/functions/ghg'
import {
  useDeleteEmissionSourceMutation,
  useUpsertEmissionSourceMutation,
  type ImpactSolutionType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmissionSourcesTable',
  props: {
    disabled: { type: Boolean, default: false },
    ghgSavingPotentialId: { default: undefined },
    ghgSavingPotentialData: { default: undefined },
    impactSolutionData: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { disabled: boolean, ghgSavingPotentialId: number, ghgSavingPotentialData: Record<string, any>, impactSolutionData: ImpactSolutionType };



const route = useRoute()
const ventureId = computed(() => route.params.venture as string)

const impactSolution = computed(() => props.impactSolutionData as ImpactSolutionType)
const ghg = computed(() => props.ghgSavingPotentialData ?? impactSolution.value?.ghgSavingPotential)
const isScenarioA = computed(() => ghg.value?.isScenarioA ?? true)
const emissionSources = computed(() => ghg.value?.emissionSources ?? [])

const { mutate: upsertEmissionSourceMutation } = useUpsertEmissionSourceMutation()
const { mutate: deleteEmissionSource } = useDeleteEmissionSourceMutation()

const ghgEmissionsCheckWarning = computed(() => {
  const sources = emissionSources.value
  const baselineSum = sources.reduce((acc: number, source: any) => {
    if (
      source.baselineConsumption == null
      || source.baselineGhgFactor == null
      || source.solutionConsumption == null
      || source.solutionGhgFactor == null
    ) {
      return acc
    }
    return acc + source.baselineConsumption * source.baselineGhgFactor
  }, 0)
  const solutionSum = sources.reduce((acc: number, source: any) => {
    if (
      source.baselineConsumption == null
      || source.baselineGhgFactor == null
      || source.solutionConsumption == null
      || source.solutionGhgFactor == null
    ) {
      return acc
    }
    return acc + source.solutionConsumption * source.solutionGhgFactor
  }, 0)
  return baselineSum < solutionSum
})

const comparativeDialogId = ref<number | null>(null)
const solutionDialogId = ref<number | null>(null)
const resetSolutionDialog = ref(0)
const resetComparativeDialog = ref(0)

const upsertEmissionSource = (value: unknown, field: string, id?: number | null) => {
  if (props.disabled || !props.ghgSavingPotentialId) return
  const input: Record<string, unknown> = {
    ghgSavingPotentialId: props.ghgSavingPotentialId,
    ventureId: ventureId.value,
    [field]: value,
  }
  if (id != null) {
    input.id = id
  }
  upsertEmissionSourceMutation({ input: input as any })
}

const addEmissionSource = () => {
  if (props.disabled || !props.ghgSavingPotentialId) return
  upsertEmissionSourceMutation({
    input: {
      ventureId: ventureId.value,
      ghgSavingPotentialId: props.ghgSavingPotentialId,
    },
  })
}

const handleDeleteEmissionSource = (id: number) => {
  if (props.disabled) return
  deleteEmissionSource({ id })
}

const openSolutionDialog = (itemId: number) => {
  if (props.disabled) return
  solutionDialogId.value = itemId
  resetSolutionDialog.value = Date.now()
}
const openComparativeDialog = (itemId: number) => {
  if (props.disabled) return
  comparativeDialogId.value = itemId
  resetComparativeDialog.value = Date.now()
}
const closeSolutionDialog = () => {
  solutionDialogId.value = null
}
const closeComparativeDialog = () => {
  comparativeDialogId.value = null
}
const handleSolutionDialogInput = (value: boolean) => {
  if (!value) closeSolutionDialog()
}
const handleComparativeDialogInput = (value: boolean) => {
  if (!value) closeComparativeDialog()
}

return { __sfc: true,props, route, ventureId, impactSolution, ghg, isScenarioA, emissionSources, upsertEmissionSourceMutation, deleteEmissionSource, ghgEmissionsCheckWarning, comparativeDialogId, solutionDialogId, resetSolutionDialog, resetComparativeDialog, upsertEmissionSource, addEmissionSource, handleDeleteEmissionSource, openSolutionDialog, openComparativeDialog, closeSolutionDialog, closeComparativeDialog, handleSolutionDialogInput, handleComparativeDialogInput, roundValue }
}

})